import React, { memo } from "react";
import useDashboard from "./index.hooks";
import { Divider } from "@material-ui/core";
import { Switch, Route, Link } from "react-router-dom";
import AppLogo from "assets/images/banner_image.png";
import { SectionListItem, DashboardDrawer, DashboardAppBar } from "components";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import {
  EventList,
  MerchantStats,
  NotificationsPage,
  ProfileSection,
  QrCodePage,
} from "../";
import NotificationsIcon from "@material-ui/icons/Notifications";
import TimelineIcon from "@material-ui/icons/Timeline";
import StoreIcon from "@material-ui/icons/Store";
import CropFreeIcon from "@material-ui/icons/CropFree";

type DashboardProps = {};

const Dashboard = ({}: DashboardProps) => {
  const {
    styles,
    sectionSlug,
    merchantId,
    isDrawerOpen,
    handleDrawerToggle,
    t,
  } = useDashboard();

  const sections = [
    {
      slug: "events",
      label: t("Eventi"),
      icon: LocalOfferIcon,
      component: EventList,
    },
    {
      slug: "qrcode",
      label: t("Verifica codice QR"),
      icon: CropFreeIcon,
      component: QrCodePage,
    },
    {
      slug: "notifications",
      label: t("Centro Notifiche"),
      icon: NotificationsIcon,
      component: NotificationsPage,
    },
    {
      slug: "stats",
      label: t("Statistiche"),
      icon: TimelineIcon,
      component: MerchantStats,
    },
    {
      slug: "profile",
      label: t("Profilo"),
      icon: StoreIcon,
      component: ProfileSection,
    },
  ];

  return (
    <div>
      <DashboardAppBar
        position="static"
        onMenuIconPressed={handleDrawerToggle}
      />
      <DashboardDrawer
        sectionSlug={sectionSlug}
        sections={sections}
        isDrawerOpen={isDrawerOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      <div className={styles.pageContent}>
        <Switch>
          {sections.map((sect) => (
            <Route
              key={sect.slug}
              path={`/merchants/${merchantId}/${sect.slug}`}
              component={sect.component}
            />
          ))}
        </Switch>
      </div>
    </div>
  );
};

export default memo(Dashboard);
